module.exports = __webpack_public_path__ + "static/img/10.ee5fde9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/sp/10.png
// module id = hJCt
// module chunks = 0